import { FC, useEffect } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { email_icon, phone_icon } from 'src/assets'
import {
  CF_MUTUA,
  CF_VITA,
  FOOTER_CLAIMS_EMAIL,
  FOOTER_EMAIL,
  FOOTER_PHONE,
  PI_GRUPPO,
} from 'src/config'
import { change_language } from 'src/i18n'
import { TO_ACCESSIBILITY, TO_COOKIE_POLICY_LIST } from 'src/navigation'
import { footer_t } from 'src/types/widgets/footer.types'
import { fill_placeholders, get_language } from 'src/utils'

import { Button } from '../button/button'

export const Footer: FC<footer_t> = ({ progress }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const progress_ = progress ? +progress.split('%')?.[0] : 100

  const classes_lang = 'font-14-semibold text-uppercase'

  const classes_it = `${classes_lang} ${get_language() === 'DE' ? 'c-7f7f7f' : ''}`
  const classes_de = `${classes_lang} ${get_language() === 'IT' ? 'c-7f7f7f' : ''}`

  useEffect(() => {
    if (get_language() !== 'IT' && get_language() !== 'DE') {
      change_language('it')
    }
  }, [])

  /**
   * Render functions
   */
  const render_phone = () => (
    <Row>
      <div className="mr-4 pr-1">
        <Image className="pt-1 filter-grey" src={phone_icon} height={21} width={21} />
      </div>
      <div className="font-20 c-7f7f7f">
        <Row>
          <span className="pt-1">{t('footer.phone_title')}</span>
        </Row>
        <Row>
          <span>{`${t('footer.phone_number_label')}: `}</span>
          <a href={`tel:${FOOTER_PHONE}`} className="pl-2 c-primary text-underline">
            {FOOTER_PHONE}
          </a>
        </Row>
        <Row>
          <span>{t('footer.phone_time_first')}</span>
        </Row>
        <Row>
          <span>{t('footer.phone_time_last')}</span>
        </Row>
      </div>
    </Row>
  )

  const render_email = () => (
    <Row className="mt-4">
      <Image className="mt-1 mr-3 filter-grey" src={email_icon} height={18} width={18} />
      <div className="font-20">
        <Row>
          <span className="ml-3 c-7f7f7f">{`${t('footer.email_title')}: `}</span>
          <a href={`mailto:${FOOTER_EMAIL}`} className="pl-2 c-primary text-underline">
            {FOOTER_EMAIL}
          </a>
        </Row>
      </div>
    </Row>
  )

  const render_links = () => {
    const props_ = {
      target: '_blank',
      rel: 'noopener noreferrer',
      className: 'ml-2 ml-md-3 c-000000 cursor-pointer',
    }
    return (
      <>
        <a {...props_} href={'https://www.gruppoitas.it/gruppo/note-legali-e-privacy'}>
          {t('footer.bottom_privacy')}
        </a>
        <a {...props_} href={TO_COOKIE_POLICY_LIST}>
          {t('footer.bottom_cookie')}
        </a>
        <a
          {...props_}
          onClick={() => {
            navigate(TO_ACCESSIBILITY)
          }}
        >
          {t('footer.bottom_accessibility')}
        </a>
        <a
          {...props_} href={`https://www.gruppoitas.it/${get_language().toLowerCase()}/reclami`}
        >
          {t('footer.bottom_claims')}
        </a>
      </>
    )
  }

  const render_language = () => (
    <div className="mt-2 mt-md-0 float-right d-flex">
      <Button
        flavor="primary_flip"
        text={t('footer.bottom_ita')}
        classes="p-0"
        classes_text={classes_it}
        on_press={() => change_language('it')}
      />
      <Button
        flavor="primary_flip"
        text={t('footer.bottom_deu')}
        classes="ml-3 p-0"
        classes_text={classes_de}
        on_press={() => change_language('de')}
      />
    </div>
  )

  const render_bottom = () => (
    <div className="mt-5 pt-4">
      <Row className="font-12-semibold text-uppercase c-7f7f7f">
        <span>{fill_placeholders(t('footer.bottom_benefit'), CF_MUTUA)}</span>
        <span className="ml-md-3">{fill_placeholders(t('footer.bottom_life'), CF_VITA)}</span>
        <span className="ml-md-3">{fill_placeholders(t('footer.bottom_group'), PI_GRUPPO)}</span>
      </Row>
      <hr className="ml-n4 mt-3 mb-3" />
      <Col className="m-0 p-0 mb-4 font-12-semibold text-uppercase">
        <span className="ml-n3 c-7f7f7f">{t('footer.bottom_copyright')}</span>
        {render_links()}
        {render_language()}
      </Col>
    </div>
  )

  return (
    <main className="ml-lg-5 pl-5 col-lg-11">
      <hr className="ml-n4 mt-5 pb-5" />
      {render_phone()}
      {render_email()}
      {render_bottom()}
    </main>
  )
}
